require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tmoignages-danciens-tudiants-0-10-0.json") })
        }
      }, "path---tmoignages-danciens-tudiants-0-10-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tmoignages-danciens-tudiants-0-10-0!./.cache/json/tmoignages-danciens-tudiants-0-10-0.json
// module id = 588
// module chunks = 231608221292675